<template>
    <div>
       

        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style="font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center">Users Management</span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="
width: 30px;
height: 30px;
border-radius: 5px;
            background-color: #007DFC;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            margin-right:8px;
          ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>

                    <span @click="showSearch()"
                          style="
                          width: 30px;
                          height: 30px;
                          border-radius: 5px;
                          background-color: #007DFC;
                          color: white;
                          display: inline-block;
                          padding-left: 5px;
                          padding-right: 5px;
                          text-align: center;
                          cursor:pointer;

                          ">
                        <i class="fa fa-search" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <input type="text" v-if="visibleSearch" class="form-control" name="searchText" id="searchText" style=" display: inline-block; width: 250px; height: 30px;" v-model="filter">
                    <userMenu />
                </div>
            </div>
        </div>

        <div class="row">

            <div class="offset-md-9 col-3 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <span style="margin-right:5px">Add New User</span>
                    <router-link class="btn btn-table" :to="{ name: 'user' }"><i class="fas fa-plus"></i></router-link>
                </div>
            </div>
        </div>

        <div v-if="message" class="alert alert-success">
            <p>{{ message }}</p>
        </div>
        <div class="table-responsive">
     
            <DataTable :value="users" :rowClass="rowClass" class="p-datatable-sm" responsiveLayout="scroll"
                       dataKey="id" v-model:filters="filters" filterDisplay="row">
                <template #header>
                    <div style="text-align:left">
                        <MultiSelect :modelValue="selectedColumns" :options="columns" optionLabel="header" @update:modelValue="onToggle"
                                     placeholder="Select Columns" style="width: 20em" />
                    </div>
                </template>
                <!--<template #header>
        <div class="flex justify-content-end">
            <span class="p-input-icon-left ">
                <i class="pi pi-search" />
                <InputText v-model="filter" placeholder="Keyword Search" />
            </span>
        </div>
    </template>-->
                <Column field="id" header="id" sortable></Column>
                
                <Column v-for="(col, index) of selectedColumns" :field="col.field" sortable :header="col.header" :key="col.field + '_' + index">
                    <template v-if="col.field == 'role'" #filter="{filterModel,filterCallback}">
                        <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="roles" placeholder="Any" class="p-column-filter" :showClear="true">
                            <template #value="slotProps">
                                <span :class="'customer-badge role-' + slotProps.value">{{slotProps.value}}</span>
                            </template>
                            <template #option="slotProps">
                                <span :class="'customer-badge role-' + slotProps.option">{{slotProps.option}}</span>
                            </template>
                        </Dropdown>
                    </template>
                    <!--<template v-else-if="col.field == 'creationDate'" #filter="{filterModel}">
        <Calendar v-model="filterModel.value" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" />
    </template>-->
                    <template v-else #filter="{filterModel,filterCallback}">
                        <InputText type="text" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter" />
                    </template>
                    <template v-if="col.field == 'companyName'" #body="slotProps">
                        {{ truncate(slotProps.data.companyName, 25) }}
                    </template>
                    <template v-else-if="col.field == 'email'" #body="slotProps">
                        {{ truncate(slotProps.data.email, 25) }}
                    </template>
                    <template v-else-if="col.field == 'username'" #body="slotProps">
                        {{ truncate(slotProps.data.username, 25) }}
                    </template>
                    <template v-else-if="col.field == 'creationDate'" #body="slotProps">
                        {{customFormatterISO(slotProps.data.creationDate)}}
                    </template>

                </Column>


                <Column :headerStyle="{width: '140px'}" :key="'actions_' + selectedColumns.length" header="Actions" :exportable="false">
                    <template #body="slotProps">
                        <template v-if="slotProps.data.isActive">
                            <a style="margin-right:6px;display:inline-block;" class="btn btn-table"> <i style="display:inline-block;" class=" fas fa-check"></i></a>
                        </template>
                        <template v-else>
                            <a style="margin-right:6px;display:inline-block;" class="btn btn-table" @click.prevent="activateUser(slotProps.data)"><i style="color: rgb(0, 125, 252);" class="fas fa-circle"></i></a>
                        </template>
                        <router-link v-if="slotProps.data.role=='Admin' || slotProps.data.role=='Management'" style="display:inline-block;" class="btn btn-table" :to="{name:'userbuildings',params:{userId:slotProps.data.id, name:slotProps.data.username}}"><i class="fas fa-building"></i></router-link>
                        <!--<button v-else style="display:inline-block;width:90px;" class="btn btn-edit">Properties</button>-->
                        <!--<a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="deleteItem(property)"><i class="fas fa-times"></i></a>-->
                        <router-link style="margin-left:6px; display:inline-block;" class="btn btn-table" :to="{name:'user',params:{id:slotProps.data.id, name:slotProps.data.username}}"><i class="fas fa-pen"></i></router-link>
                        <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="deleteItem(slotProps.data)"><i class="fas fa-times"></i></a>

                    </template>
                </Column>
                <!--<Column field="price" header="Price" sortable>
        <template #body="slotProps">
            {{formatCurrency(slotProps.data.price)}}
        </template>
    </Column>-->
            </DataTable>
    </div>
        <!--<div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th style="cursor:pointer;" @click="sort('id')" scope="col"><span class="sort-by">No</span></th>
                        <th style="cursor:pointer;" @click="sort('companyName')" scope="col"><span class="sort-by">Company</span></th>
                        <th scope="col">Price</th>
                        <th scope="col">Comm. %</th>
                        <th style="cursor:pointer;" @click="sort('email')" scope="col"><span class="sort-by">Email</span></th>
                        <th style="cursor:pointer;" @click="sort('phoneNumber')" scope="col"><span class="sort-by">Phone Number</span></th>
                        <th style="cursor:pointer;" @click="sort('postalCode')" scope="col"><span class="sort-by">Postal Code</span></th>
                        <th style="cursor:pointer;" @click="sort('creationDate')" scope="col"><span class="sort-by">Creation Date</span></th>

                        <th style="cursor:pointer;" @click="sort('username')" scope="col"><span class="sort-by">Username</span></th>
                        <th style="cursor:pointer;" @click="sort('firstName')" scope="col"><span class="sort-by">Name</span></th>
                        <th style="cursor:pointer;" @click="sort('lastName')" scope="col"><span class="sort-by">Surname</span></th>

                        <th style="cursor:pointer;" @click="sort('role')" scope="col"><span class="sort-by">Roles</span></th>
                        <th scope="col" colspan="2" class="text-right" style='padding-right:80px'>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user, key in getUsers" class="clickable-row">
                        <td scope="row">{{ user.id }}</td>
                        <td>{{ truncate(user.companyName, 25) }}</td>
                        <td>{{ user.price }}</td>
                        <td>{{ user.commission }}</td>
                        <td data-tooltip="{user.email}">{{ truncate(user.email, 25) }}</td>
                        <td>{{ user.phoneNumber }}</td>
                        <td>{{ user.postalCode }}</td>
                        <td>{{ customFormatterISO(user.creationDate) }}</td>
                        <td>{{ truncate(user.username, 25) }}</td>
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.lastName }}</td>

                        <td>
                            {{ user.role }}
                        </td>
                        <td style="text-align:right;">
                            <template v-if="user.isActive">
                                <a style="margin-right:6px;display:inline-block;" class="btn btn-table"> <i style="display:inline-block;" class=" fas fa-check"></i></a>
                            </template>
                            <template v-else>
                                <a style="margin-right:6px;display:inline-block;" class="btn btn-table" @click.prevent="activateUser(user)"><i style="color: rgb(0, 125, 252);" class="fas fa-circle"></i></a>
                            </template>
                            <router-link v-if="user.role=='Admin' || user.role=='Management'" style="display:inline-block;" class="btn btn-table" :to="{name:'userbuildings',params:{userId:user.id, name:user.username}}"><i class="fas fa-building"></i></router-link>-->
                            <!--<button v-else style="display:inline-block;width:90px;" class="btn btn-edit">Properties</button>-->
                            <!--<a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="deleteItem(property)"><i class="fas fa-times"></i></a>-->
                            <!--<router-link style="margin-left:6px; display:inline-block;" class="btn btn-table" :to="{name:'user',params:{id:user.id, name:user.username}}"><i class="fas fa-pen"></i></router-link>
                            <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="deleteItem(user)"><i class="fas fa-times"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>-->
        <modal :scrollable="true" name="deleteAlert" @before-open="beforeOpen" height="auto" :minHeight="150" width="400">
            <div class="" role="document">
                <div class="">
                    <!-- Modal content-->
                    <deleteAlert v-on:close="modalClosed" :entity-id="selectedItemId" request="users" entity="user" />
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import { format, parseISO } from "date-fns";
    import { userService } from '@/_services';
    import { FilterMatchMode, FilterOperator } from '@primevue/core/api';
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    import InputText from 'primevue/inputtext';
    import Dropdown from 'primevue/select';
    import MultiSelect from 'primevue/multiselect';
    import Calendar from 'primevue/datepicker';

export default {
    data () {
        return {
            filters: {
                'companyName': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'email': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'phoneNumber': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'postalCode': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'username': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'firstName': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'lastName': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'role': { value: null, matchMode: FilterMatchMode.EQUALS },
              //  'creationDate': { value: null, matchMode: FilterMatchMode.DATE_IS },
            },
            filter: '',
            visibleSearch: false,
            users:[],
            message: '',
            currentSort: 'id',
            currentSortDir: 'asc',
            selectedItemId: 0,
            selectedColumns: null,
            columns: null,
            roles: [
                'Admin', 'Management', 'Owner'
            ]
        }
        },
        components: {
            DataTable,
            Column,
            FilterMatchMode,
            FilterOperator,
            InputText,
            MultiSelect,
            Dropdown,
            Calendar
        },
        methods: {
            truncate(data, num) {
                if (data == null)
                    return ""
                const reqString =
                    data.split("").slice(0, num).join("");
                return reqString;
            },
            rowClass(data) {
                return 'clickable-row';
            },
            onToggle(value) {
                this.selectedColumns = this.columns.filter(col => value.includes(col));
            },
            sort: function (s) {
                if (s === this.currentSort) {
                    this.currentSortDir = this.currentSortDir ==='asc'?'desc':'asc'
                }
                this.currentSort = s
            },
            showSearch() {
                this.visibleSearch = !this.visibleSearch;
            },
            customFormatterISO(date) {
                 if (date == null)
                    return "-"
                return format(parseISO(date), "dd/MM/yyyy");
            },
            
            activateUser(item) {
                this.$http
                    .post("/users/activateUser?id=" + item.id,)
                    .then(
                        () => {
                            userService.getAll().then(users => this.users = users);
                        },
                        () => {
                            alert("error");
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                        }
                    )
            },
            deleteItem: function destroy(item) {
                this.selectedItemId = item.id;
                this.deleteAlert();
            },

            deleteAlert: function () {
                this.$modal.show("deleteAlert");
            },
            modalClosed: function (itemDeleted) {
                if (itemDeleted)
                    userService.getAll().then(users => this.users = users);
            },
        },
        created() {
            this.columns = [
                { field: 'companyName', header: 'Company' },
                { field: 'email', header: 'Email' },
                { field: 'phoneNumber', header: 'Phone number' },
                { field: 'postalCode', header: 'Postal Code' },
                { field: 'creationDate', header: 'Creation Date' },
                { field: 'username', header: 'Username' },
                { field: 'firstName', header: 'Name' },
                { field: 'lastName', header: 'Surname' },
                { field: 'role', header: 'Role' },
            ];

            this.selectedColumns = [
                { field: 'companyName', header: 'Company' },
                { field: 'email', header: 'Email' },
                { field: 'phoneNumber', header: 'Phone number' },
           //     { field: 'postalCode', header: 'Postal Code' },
               // { field: 'creationDate', header: 'Creation Date' },
               // { field: 'username', header: 'Username' },
                { field: 'firstName', header: 'Name' },
                { field: 'lastName', header: 'Surname' },
                { field: 'role', header: 'Role' },
            ];


                //this.columns;
        },
    mounted(){
       //  this.$store.dispatch('users/getAll').then(users => this.users = users);
       userService.getAll().then(users => this.users = users);
        },
        computed: {
            getUsers() {
              var  users = this.users.filter((user) => {

                    return user.name.toLowerCase().includes(this.filter.toLowerCase());
                });

              
                return users.sort((a, b) => {
                    let modifier = 1
                    if (this.currentSortDir === "desc")
                        modifier = -1
                    if (a[this.currentSort] < b[this.currentSort])
                        return -1 * modifier
                    if (a[this.currentSort] > b[this.currentSort])
                        return 1 * modifier
                    return 0
                })
            },
        },
}
</script>